import type {ReactElement} from 'react';
import React from 'react';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

export function LayoutHighlightedTextColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemHighlightedTextColor = useGetKeyFromTableItem('highlightedTextColor');

  if (!activeItem || (activeItem && !('highlightedTextColor' in activeItem)) || !itemHighlightedTextColor) {
    throw new Error('Item does not have highlightedTextColor property');
  }

  const updateColor = (highlightedTextColor: RGBA, undoable = true): void => {
    activeItem.updateHighlightedTextColor(highlightedTextColor, undoable);
  };

  const onChangeColor = (updatedColor: ColorStorage[]): void => {
    updateColor(updatedColor[0].color, false);
  };

  const onChangeEnded = (updatedColor: ColorStorage[]): void => {
    updateColor(updatedColor[0].color);
  };

  return (
    <PosterEditingBaseColorPanel
      id="schedule-highlighted-text-color-panel"
      isGradientEnabled={false}
      color={getColorObjectArrayFromFillColor([itemHighlightedTextColor])}
      onChangeColor={onChangeColor}
      onChangeEnded={onChangeEnded}
    />
  );
}
